export default "__VITE_ASSET__CKAW2$B2__"